import { Button } from "@sgi/gravity/Button";
import { useEffect, useMemo, useState } from "react";
import { useWrapper } from "../Context/WrapperContext";

export default function DevControls() {
  const [visibility, setVisibility] = useState("hidden");
  const [currentIndex, setCurrentIndex] = useState<number>();

  const data = useMemo(() => ["Unified", "SelfAsserted", "none"], []);
  const { increment, decrement } = useWrapper();

  let input = document.getElementById("api") as HTMLElement;

  useEffect(() => {
    if (input) input.style.visibility = visibility;
  }, [visibility, input]);

  function toggleVisibility() {
    if (visibility === "visible") {
      setVisibility("hidden");
    } else {
      setVisibility("visible");
    }
  }

  function togglePage() {
    setCurrentIndex(
      (prevIndex) => (prevIndex ? prevIndex + 1 : 1) % data.length
    );
    input.setAttribute("data-name", data[currentIndex ?? 0]);
  }

  return process.env.ENABLE_DEV_CONTROLS === "true" ? (
    <div style={{ textAlign: "center" }}>
      <Button onClick={decrement}>-</Button>
      <Button onClick={increment}>+</Button>
      <Button onClick={toggleVisibility} data-testid="toggle-test">
        {visibility}
      </Button>
      <Button onClick={togglePage} data-testid="toggle-page-test">
        Toggle page
      </Button>
    </div>
  ) : (
    <></>
  );
}
